var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconFriendRed = function SvgIconFriendRed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-friends",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_27",
    "data-name": "Group 27",
    transform: "translate(-317.159 -274.449)",
    fill: "#F66969"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_120",
    "data-name": "Path 120",
    d: "M319.159 294.937v3.512h20v-3.512c0-3.578-4.485-6.488-10-6.488s-10 2.91-10 6.488Z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_30",
    "data-name": "Ellipse 30",
    cx: 6,
    cy: 6,
    r: 6,
    transform: "translate(323.159 274.449)"
  }))));
};
export { SvgIconFriendRed as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyBpZD0iaWNvbi1mcmllbmRzIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij4KICA8cmVjdCBpZD0iYXJlYSIgd2lkdGg9IjI0IiBoZWlnaHQ9IjI0IiBmaWxsPSIjZmZmIiBvcGFjaXR5PSIwIi8+CiAgPGcgaWQ9Ikdyb3VwXzI3IiBkYXRhLW5hbWU9Ikdyb3VwIDI3IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMzE3LjE1OSAtMjc0LjQ0OSkiPgogICAgPHBhdGggaWQ9IlBhdGhfMTIwIiBkYXRhLW5hbWU9IlBhdGggMTIwIiBkPSJNMzE5LjE1OSwyOTQuOTM3djMuNTEyaDIwdi0zLjUxMmMwLTMuNTc4LTQuNDg1LTYuNDg4LTEwLTYuNDg4UzMxOS4xNTksMjkxLjM1OSwzMTkuMTU5LDI5NC45MzdaIiBmaWxsPSIjRjY2OTY5Ii8+CiAgICA8Y2lyY2xlIGlkPSJFbGxpcHNlXzMwIiBkYXRhLW5hbWU9IkVsbGlwc2UgMzAiIGN4PSI2IiBjeT0iNiIgcj0iNiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMzIzLjE1OSAyNzQuNDQ5KSIgZmlsbD0iI0Y2Njk2OSIvPgogIDwvZz4KPC9zdmc+Cg==";